export enum ModuloEnum {
  Core = 1,
  Financeiro = 2,
  Vistoria = 3
}

export const ModuloEnumNome = new Map<ModuloEnum, string>([
  [ModuloEnum.Core, 'Básico'],
  [ModuloEnum.Financeiro, 'Financeiro'],
  [ModuloEnum.Vistoria, 'Vistoria']
]);
